const services = [
  {
    name: 'Wise',
    description: 'Transferencias internacionales con la tasa real del mercado y comisiones bajas y transparentes.',
    fee: 'Desde 0.43%',
    time: '1–2 días hábiles',
    badge: 'Mejor tasa',
    badgeColor: 'bg-green-100 text-green-700',
    icon: 'ri-exchange-dollar-line',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
    highlight: true,
    url: 'https://remesasve.com',
  },
  {
    name: 'Remitly',
    description: 'Especializado en remesas a Latinoamérica con múltiples opciones de entrega y precios competitivos.',
    fee: 'Varía según el monto',
    time: 'Minutos o hasta 3 días',
    badge: 'Muy rápido',
    badgeColor: 'bg-amber-100 text-amber-700',
    icon: 'ri-send-plane-2-line',
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-600',
    highlight: false,
    url: 'https://remesasve.com',
  },
  {
    name: 'Western Union',
    description: 'Red global con años de experiencia. Permite envíos en efectivo o a cuentas bancarias en Venezuela.',
    fee: 'Varía según destino',
    time: 'Minutos a 5 días',
    badge: 'Red global',
    badgeColor: 'bg-gray-100 text-gray-700',
    icon: 'ri-global-line',
    iconBg: 'bg-gray-50',
    iconColor: 'text-gray-600',
    highlight: false,
    url: 'https://remesasve.com',
  },
];

export default function ComparisonSection() {
  return (
    <section id="comparar" className="py-20 md:py-28 bg-green-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-green-600 text-xs font-bold uppercase tracking-widest mb-3">
            Comparador de servicios
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">
            Mejor forma de enviar dinero
          </h2>
          <p className="text-gray-600 text-base max-w-lg mx-auto leading-relaxed">
            Cada servicio aplica comisiones y tipos de cambio distintos. Compara las opciones disponibles y elige la que más dinero hace llegar a tu familia en Venezuela.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.name}
              className={`relative bg-white rounded-2xl p-7 flex flex-col transition-all hover:-translate-y-1 ${
                service.highlight ? 'ring-2 ring-green-500' : ''
              }`}
            >
              {service.highlight && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="bg-green-500 text-white text-xs font-bold uppercase tracking-wider px-4 py-1 rounded-full whitespace-nowrap">
                    ★ Recomendado
                  </span>
                </div>
              )}

              {/* Icon + Badge */}
              <div className="flex items-start justify-between mb-5">
                <div className={`w-12 h-12 rounded-xl ${service.iconBg} flex items-center justify-center`}>
                  <i className={`${service.icon} text-2xl ${service.iconColor} w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <span className={`text-xs font-bold px-3 py-1 rounded-full ${service.badgeColor} whitespace-nowrap`}>
                  {service.badge}
                </span>
              </div>

              <h3 className="text-xl font-extrabold text-gray-900 mb-2">{service.name}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-5 flex-1">{service.description}</p>

              {/* Info rows */}
              <div className="space-y-2 mb-6 border-t border-gray-100 pt-4">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400 flex items-center gap-1.5">
                    <i className="ri-percent-line w-4 h-4 flex items-center justify-center"></i>
                    Comisión
                  </span>
                  <span className="font-semibold text-gray-700">{service.fee}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400 flex items-center gap-1.5">
                    <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                    Tiempo
                  </span>
                  <span className="font-semibold text-gray-700">{service.time}</span>
                </div>
              </div>

              <a
                href={service.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className={`w-full text-center font-bold text-sm rounded-full py-3 transition-all cursor-pointer whitespace-nowrap ${
                  service.highlight
                    ? 'bg-green-600 hover:bg-green-500 text-white'
                    : 'bg-gray-100 hover:bg-green-600 hover:text-white text-gray-700'
                }`}
              >
                Enviar con {service.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
